import { DriveServiceKey, type DriveService } from '@blpde/connect';

/** Bridge for hosted modules that cannot inject Vue keys. */
export function installDriveFormicaBridge(service: DriveService): void {
  if (typeof window === 'undefined') return;
  const bridged = window as Window & { formica?: { drive?: DriveService } };
  bridged.formica = {
    ...bridged.formica,
    drive: service,
  };
}

export { DriveServiceKey };
